module.exports = __webpack_public_path__ + "img/header.f83c49c5.png";